import environment from "src/utils/environment";

export default function resolveDeviceName() {
  if (environment.isBrowser) return "Web Browser";

  const os = window.require("os");
  return os.hostname().replace(".local", "").replace(/[-.]/g, " ");
}
